import { Loader2Icon } from "lucide-react";

import { cn } from "@diverge/ui/lib/utils";

export interface SpinnerProps {
  size?: "sm" | "default" | "lg";
  className?: string;
  "aria-label"?: string;
}

const sizeClasses = {
  sm: "size-4",
  default: "size-6",
  lg: "size-8",
} as const;

export function Spinner({
  size = "default",
  className,
  "aria-label": ariaLabel = "Loading",
}: SpinnerProps) {
  return (
    <Loader2Icon
      role="status"
      aria-label={ariaLabel}
      className={cn("animate-spin text-muted-foreground", sizeClasses[size], className)}
    />
  );
}
